import { render, staticRenderFns } from "./FormTableHistoricalComponent.vue?vue&type=template&id=30aad660&"
import script from "./FormTableHistoricalComponent.vue?vue&type=script&lang=js&"
export * from "./FormTableHistoricalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports